import React from "react";
import AIAssessmentDisplay from "../AIAssessmentDisplay";

const AIAssessmentPanel = ({
  assessment,
  canUsePronunciationApi,
  segment,
}) => {
  if (!assessment) return null;

  return (
    <div className="p-4 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 backdrop-blur-sm rounded-2xl border border-purple-200/50 shadow-lg shadow-purple-500/5">
      {!canUsePronunciationApi && (
        <div className="text-red-500 text-sm font-semibold text-center mb-3 p-3 bg-red-50 rounded-lg border border-red-200/50">
          Public mode: intonation feedback only. Log in for full AI pronunciation assessment.
        </div>
      )}

      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl shadow-lg shadow-purple-500/25">
          <span className="text-white text-lg">🤖</span>
        </div>
        <div>
          <h3 className="font-bold text-gray-800">AI Assessment</h3>
          <p className="text-gray-600 text-xs">Detailed feedback</p>
        </div>
      </div>

      <AIAssessmentDisplay
        assessment={assessment}
        segment={segment}
      />
    </div>
  );
};

export default AIAssessmentPanel;